import { Button, Icon } from "@qw/ui";
import { useState } from "react";

import { ProductMetadataDialog } from "./product-form/product-metadata-dialog";

export const NewProductButton = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setDialogOpen(true)}>
        <Icon icon="add" /> New Product
      </Button>
      <ProductMetadataDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  );
};
